import { render, staticRenderFns } from "./ReportMealsTabPackages.vue?vue&type=template&id=61bd7b32&scoped=true"
import script from "./ReportMealsTabPackages.vue?vue&type=script&lang=js"
export * from "./ReportMealsTabPackages.vue?vue&type=script&lang=js"
import style0 from "./ReportMealsTabPackages.vue?vue&type=style&index=0&id=61bd7b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bd7b32",
  null
  
)

export default component.exports